import React, { useEffect, useState } from "react"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"

import layoutStore from "layoutStore"

//components
import Navbar from "./Navbar"
import Header from "./Header"
import Footer from "./Footer"

import userStore from "userStore"

const Layout = props => {
  const changes = userStore(state => state.changes)
  const topbarTheme = layoutStore(state => state.topbarTheme)
  const { pathname } = props.location
  const { permissionBy } = props.children.props

  useEffect(() => {
    const title = pathname
    const splitUrl = title.split("/")[1]
    const upperCase = splitUrl.charAt(0).toUpperCase() + splitUrl.slice(1)

    document.title = upperCase.replaceAll("-", " ") + " | EWAN "
  }, [pathname])

  useEffect(() => {
    if (pathname == "/alta-titular" || pathname == "/nueva-solicitud") {
      userStore.setState({ changes: false })
    }
  }, [pathname, changes])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    document.body.setAttribute("data-layout", "horizontal")
    document.body.setAttribute("data-topbar", "light")
    layoutStore.getState().changeLayout("horizontal")
  }, [])

  useEffect(() => {
    if (topbarTheme) {
      layoutStore.getState().changeTopbarTheme(topbarTheme)
    }
  }, [topbarTheme])

  const [leftMen, setMenLeft] = useState(true)
  const toggleLeftmen = () => setMenLeft(!leftMen)

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header theme={topbarTheme} toggleLeftmen={toggleLeftmen} />

        <Navbar leftMen={leftMen} color="red" />

        <div className="main-content">
          {React.cloneElement(props.children, { permissionBy })}
        </div>

        <Footer />
      </div>
    </React.Fragment>
  )
}

Layout.propTypes = {
  children: PropTypes.object,
  location: PropTypes.object,
  topbarTheme: PropTypes.any,
}

export default withRouter(Layout)
